import styled from 'styled-components'

import Icon from 'components/icons'
import Link from 'components/link'
import mediaQueries from 'components/media-queries'
import { common } from 'constants/e2eClasses'
import { toTesteableId } from 'helpers/utils'

export const Container = styled.div.attrs(props => ({
  className: `${toTesteableId(props.e2eClass || '')}`
}))`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  flex-wrap: wrap;

  ${mediaQueries.tablet`
    flex-direction: column;
    align-items: flex-start;
  `};

  ${mediaQueries.mobile`
    align-items: center;
    justify-content: center;
  `};
`

export const Title = styled.label`
  display: none;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  text-align: left;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;

  ${mediaQueries.mobile`
    display: block;
  `};
`

export const InputWrapper = styled.div.attrs(props => ({
  className: `${toTesteableId(props.e2eClass || '')}`
}))`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-right: 35px;
  margin-bottom: ${({ error }) => (error ? '30px' : '0')};

  ${mediaQueries.tablet`
    width: 400px;
    margin-right: 0;
    margin-bottom: 30px;
  `};

  ${mediaQueries.mobile`
    width: 100%;
    margin-right: 0;
    margin-bottom: 30px;
  `};
`

export const IconWithMargin = styled(Icon)`
  margin: 9px 0 0 8px;
`

export const Label = styled.label.attrs(props => ({
  className: `${common.label}${toTesteableId(props.e2eClass || '')}`
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  padding: 14px 0;
  color: ${({ theme }) => theme.colors.doveGray};

  ${mediaQueries.tablet/*Hides visually but not for screen-readers*/ `
    clip: rect(0 0 0 0); 
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap; 
    width: 1px;
  `};
`

export const Button = styled.button.attrs(props => ({
  className: `${toTesteableId(props.e2eClass || '')}`
}))`
  background-color: ${({ theme }) => theme.colors.blue};
  border: none;
  border-radius: 3px;
  color: ${({ theme }) => theme.colors.white};
  padding: 15px 30px;
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  outline: none;
  cursor: pointer;
  margin-bottom: ${({ error }) => (error ? '30px' : '0')};
  order: 3;

  ${mediaQueries.tablet`
    width: 400px;
  `};

  ${mediaQueries.mobile`
    width: 100%;
    padding: 10px 30px;
    margin-bottom: 20px;
  `};
`

export const ErrorWrapper = styled.div`
  display: flex;
  padding-top: 43px;
  width: 55%;
  ${mediaQueries.mobile`
    width: 100%;
  `};
`

export const ErrorText = styled.div`
  display: flex;
  flex-direction: column;
`

export const ErrorTitle = styled.div`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 20px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  margin-bottom: 16px;
  width: 85%;
`

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.regular};
`

export const StyledLink = styled(Link)`
  margin-top: 8px;
  font-size: 14px;
`

export const ErrorImage = styled.img`
  margin-left: 40px;
`

export const SwitcherContainer = styled.div`
  padding-top: 11px;
  order: 4;
  flex-basis: 100%;
`

export const MessageContainer = styled.div``

export const Text = styled.span``
